import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12 22C6.47967 21.9939 2.00606 17.5203 2 12V11.8C2.10993 6.30452 6.63459 1.92794 12.1307 2.00087C17.6268 2.07379 22.0337 6.56887 21.9978 12.0653C21.9619 17.5618 17.4966 21.9989 12 22ZM12 3.99999C7.58172 3.99999 4 7.58171 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C19.995 7.58377 16.4162 4.00495 12 3.99999ZM12 17L10.59 15.59L13.17 13H7V11H13.17L10.59 8.40999L12 6.99999L17 12L12 17Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "CircleRight"
);
